(function() {

  // ── All UpPromote + discount cookies to nuke ──
  const COOKIES_TO_CLEAR = [
    'discount_code',
    'scaaf_afc',
    'scaaf_affn',
    'scaaf_afn',
    'scaaf_aid',
    'scaaf_c_c',
    'scaaf_ctk',
    'scaaf_ep',
    'scaaf_pd',
    'scaaf_tid',
    'up_uppromote_aid',
    'up_uppromote_hs',
    'up_uppromote_lc',
    'up_uppromote_received'
  ];

  // ── YOUR affiliate ref ──
  const OUR_SCA_REF = '11437298.SjHYtOq5glN6ZJi';

  function forceDeleteCookie(name) {
    const host = window.location.hostname;
    const domainParts = host.split('.');
    const rootDomain = domainParts.length > 2
      ? '.' + domainParts.slice(-2).join('.')
      : host;

    // Delete against all combinations of path and domain
    const combos = [
      `path=/;`,
      `path=/; domain=${host};`,
      `path=/; domain=${rootDomain};`,
      `path=/; domain=.${host};`
    ];

    combos.forEach(function(attrs) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${attrs}`;
    });
  }

  async function clearEverything() {
    // 1. Nuke all affiliate + discount cookies
    COOKIES_TO_CLEAR.forEach(forceDeleteCookie);
    console.log('[NattyPLUS] Affiliate cookies cleared.');

    // 2. Clear Shopify cart discount on the backend
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
      console.log('[NattyPLUS] Shopify cart discount cleared.');
    } catch (err) {
      console.error('[NattyPLUS] Failed to clear cart discount:', err);
    }
  }

  const url = new URL(window.location.href);
  const scaRef = url.searchParams.get('sca_ref');

  if (!scaRef) return; // No affiliate link in URL at all, do nothing

  // whoever is most recent wins — always clear on any affiliate link visit
  // so old cookies never bleed into the new session
  clearEverything();

  // if it's OUR link specifically, log it (extend here later if needed)
  if (scaRef === OUR_SCA_REF) {
    console.log('[NattyPLUS] Own affiliate link detected — full clear done.');
  } else {
    console.log('[NattyPLUS] External affiliate link detected — full clear done so theirs can take over cleanly.');
  }

})();